export enum pageStateType {
  SET_PAGE_STATE_REQUEST = 'SET_PAGE_STATE_REQUEST',
  SET_PAGE_STATE_SUCCESS = 'SET_PAGE_STATE_SUCCESS',
  SET_PAGE_STATE_FAILURE = 'SET_PAGE_STATE_FAILURE',
}
